/** @jsx jsx */

import { MouseEventHandler } from 'react';

import { Spacer, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Link from 'app/common/components/Link';

import Button from './Button';
import Page from './Page';

const Styles = {
  root: css`
    text-align: center;
  `,
};

type Props = {
  name: string;
  onClickRetry: MouseEventHandler<HTMLAnchorElement>;
};

function ErrorView({ name, onClickRetry }: Props) {
  return (
    <Page css={Styles.root}>
      <Text tag="h1" type="SectionHeader">
        Unable to join integration
      </Text>
      <Spacer height={40} />
      <Text color="GrayWarm7" tag="p">
        {name} may not have enabled this feature, or the email you entered may
        not have the correct email domain for {name}.
      </Text>
      <Text color="GrayWarm7" tag="p">
        Please contact the Admin for your integration or Zapier Partner Support.
      </Text>
      <Spacer height={40} />
      <Button href="/contact" target="_blank">
        Contact Support
      </Button>
      <Spacer height={25} />
      <Text color="GrayWarm7" tag="p">
        Or{' '}
        <Link href="/join-integration" onClick={onClickRetry}>
          try again
        </Link>
      </Text>
    </Page>
  );
}

export default ErrorView;
